<template>
  <div class="MainWrapper" :class="floatSet">
    <div class="carouseWrapper">
      <el-carousel height="600px" indicator-position="outside">
        <el-carousel-item v-for="item in List.jpgList" :key="item">
          <img :src="item" alt="" class="imgSet">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="contentWrapper">
      <div class="title">{{ List.title }}</div>
      <div class="separator"></div>
      <div class="detai">{{ List.content }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dwgzmd",
  props: ["floatSet", "List"],
  data() {
    return {};
  },
};
</script>


<style scoped>
.MainWrapper {
  width: 705px;
  margin-top: 8%;
  position: relative;
  height: 800px;
}

.carouseWrapper {
  width: 900px;
}

.rightSet > .carouseWrapper {
  float: right;
}

.leftSet > .carouseWrapper {
  float: left;
}

.contentWrapper {
  position: absolute;
  width: 370px;
  height: 370px;
  padding: 0 42px;
  top: 50%;
  margin-top: -300px;
  color: #fff;
  box-shadow: 0 0 8px 4px rgba(92, 77, 36, 0.18);
  z-index: 999;
  text-align: left;
  letter-spacing:1.5px;
}

.title {
  font-size: 32px;
  font-weight: 400;
  margin-top: 70px;
}

.separator{
    width: 74px;
    height: 12px;
    margin-top: 25px;
    background: url("./jpg/whiteLine.png");
}

.detai{
      font-size: 14px;
    line-height: 27px;
    font-weight: lighter;
    margin: 25px 0;
}

.imgSet{
  display: block;
    max-width: 100%;
    height: auto;
}

.rightSet > .contentWrapper {
  right: -30%;
  background: rgba(195, 166, 95, 0.9);
}

.leftSet > .contentWrapper {
  left: -30%;
  background: rgba(110, 110, 110, 0.92);
}

</style>


// WEBPACK FOOTER //
// src/components/dwgwzmd.vue